import { render, staticRenderFns } from "./EmployeeFormSubmissionCommentCard.vue?vue&type=template&id=7e60ce39&"
import script from "./EmployeeFormSubmissionCommentCard.vue?vue&type=script&lang=ts&"
export * from "./EmployeeFormSubmissionCommentCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports